import React from "react";

interface ShellProps {
  children: React.ReactNode;
  className?: string;
}

export function Shell({ children, className = "" }: ShellProps) {
  return (
    <div className={`flex flex-col min-h-screen ${className}`}>
      {children}
    </div>
  );
}